import { IconButtonClassKey, StyleRules, Theme } from '@material-ui/core';

type IconButtonStyles = Partial<StyleRules<IconButtonClassKey>>

export const iconButtonStyles = (theme: Theme) => ({
  root: {
    padding: theme.spacing(1)
  }
} as IconButtonStyles);
